module.exports = __webpack_public_path__ + "img/569.6650fa19.jpg";